var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAppleStore = function SvgAppleStore(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "apple-store-a",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#25C7F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#1D70F2"
  })))), /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#apple-store-a)",
    d: "M24.91 32H7.09C3.19 32 0 28.81 0 24.91V7.09C0 3.19 3.19 0 7.09 0h17.824C28.81 0 32 3.19 32 7.09v17.824C32 28.81 28.81 32 24.91 32z",
    style: {
      fill: "url(#apple-store-a)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M17.68 10.125l-1.718 2.981.57.992-3.748-6.497a1.49 1.49 0 1 1 2.581-1.49l2.316 4.014zm.544.942l7.385 12.798a1.49 1.49 0 0 1-2.581 1.49l-5.635-9.766c-.369-3.855.815-4.513.831-4.522z",
    style: {
      fill: "#FFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M11.177 21.4l-3.431-.01-.416.724c2.313-1.165 2.912.75 2.942.855l-1.376 2.386a1.49 1.49 0 1 1-2.581-1.49L16.558 6.112a1.49 1.49 0 0 1 2.035-.547c.71.412.955 1.322.543 2.036L11.177 21.4z",
    style: {
      fill: "#FFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M20.705 21.39l-1.718-2.98h7.252a1.49 1.49 0 0 1 .003 2.98h-5.537zm-1.736 0H5.755a1.49 1.49 0 0 1 0-2.98h11.556c.2.058 2.845.865 1.658 2.98z",
    style: {
      fill: "#FFF"
    }
  }))));
};
export default SvgAppleStore;